import { merge } from 'ts-deepmerge';

/**
 * target and update nested values in reactive vars storing objects
 *
 * @param {Function} reactiveVar - An Apollo reactive var function
 * @param {String} updateKey - The top-level key inside the reactive var object to update
 * @param {Object|any} update - The new value(s) for that key
 * @param {Object} [options] - Optional configuration
 * @param {String[]} [options.overrideKeys] - These keys in 'update' will be overwritten instead of merged
 *
 */
const updateNestedVar = (reactiveVar, updateKey, update, options = {}) => {
  const { overrideKeys } = options;
  const fullVar = { ...reactiveVar() };

  if (typeof update === 'object' && update !== null) {
    const nestedObj = { ...(fullVar[updateKey] || {}) };

    (overrideKeys || []).forEach((key) => {
      if (update?.[key]) {
        nestedObj[key] = update[key];
        delete update[key];
      }
    });

    fullVar[updateKey] = merge.withOptions({ mergeArrays: false }, nestedObj, update);
  } else {
    fullVar[updateKey] = update;
  }

  reactiveVar(fullVar);
};

export default updateNestedVar;